<template>
<v-list class='grey lighten-4 ma-0 pa-0' :dense='dense' >
  <practitioner-list-item
    :item='selected'
    @selected='showmenu=false;showmenu=true' >
    <template slot='title' slot-scope="props" >
      <v-list-tile-title v-if='props.fullname'>{{ props.fullname }}</v-list-tile-title>
      <v-list-tile-title v-else >Choose a practitioner</v-list-tile-title>
    </template>

    <v-list-tile-action slot='action' >
      <v-menu v-model='showmenu' offset-y left >
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" >
            <v-icon>expand_more</v-icon>
          </v-btn>
        </template>
        <v-list dense style='width:300px;' class='pa-0' >
          <v-subheader class='overline py-0 my-0 grey lighten-2' >Pick a practitioner</v-subheader>
          <v-divider/>
          <practitioner-list-item
            v-for='(practitioner, index) in practitioners' :key='practitioner.id'
            :item='practitioners[index]'
            @selected="setSelected"
            badge-color='success'
            :badge-icon='getSelectedIcon(practitioner)'
            :class='{"blue lighten-5": isSelected(practitioner)}' >
          </practitioner-list-item>
        </v-list>
      </v-menu>
    </v-list-tile-action>
  </practitioner-list-item>
</v-list>
</template>
<script>
import PractitionerListItem from '@/components/listitems/PractitionerListItem'
import { mapGetters } from 'vuex'
// import Vue from 'vue'
export default {
  name: 'PractitionerPicker',
  components: {PractitionerListItem},
  props: {
    value: { type: Object },
    dense: { type: Boolean, default: false }
  },
  data () {
    return {
      showmenu: false,
      selected: {}
    }
  },
  methods: {
    isSelected (practitioner) {
      return practitioner.id === this.practitionerId
    },
    getSelectedIcon (practitioner) {
      if (this.isSelected(practitioner)) {
        return 'check'
      }
      return null
    },
    setSelected (practitioner) {
      // Vue.set(this.selected, practitioner)
      this.selected = practitioner
      this.$emit('input', this.selected)
      this.$emit('selected', this.selected)
    }
  },
  mounted () {
    if (!this.value && this.meId) {
      this.selected = this.meId
      this.$emit('input', this.selected)
    }
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        if (this.value && this.value.id) {
          let lookup = this.getPractitionerById(this.value.id)
          if (lookup) {
            this.setSelected(lookup)
          }
        }
      }
    },
    meId () {
      if (!this.selected.id) {
        this.selected = this.me
        this.$emit('input', this.selected)
      }
    }
  },
  computed: {
    ...mapGetters(['me', 'meId', 'lookups', 'getPractitionerById']),
    practitionerId () {
      if (this.selected && this.selected) { return this.selected.id }
      return null
    },
    practitioners () {
      return this.$store.getters.getColleagues
      // return this.getColleagues
      // return this.lookups.practitioners
    },
    practitioner () {
      let practitionerId = this.practitionerId
      if (!practitionerId) { practitionerId = this.meId }
      return this.getPractitionerById(practitionerId)
    }
  }
}
</script>
<style scoped>
.selected { color: red; }
</style>



// WEBPACK FOOTER //
// PractitionerPicker.vue?4529fd30